(function () {
    'use strict';

    angular
            .module('imnApp', [
                'ngStorage',
                'ngCookies',
                'ngAnimate',
                'ui.bootstrap',
                'ui.router',
                'ui.select',
                'tmh.dynamicLocale',
                'angular-loading-bar',
                'pascalprecht.translate',
                'ngScrollbars',
                'uiSwitch',
                'nvd3',
                'toastr',
                'rzModule',
                'angularUtils.directives.dirPagination'
            ])
            .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$templateCache'];

    function run(stateHandler, translationHandler, $templateCache) {

        var templateName = 'bootstrap/match.tpl.html';
        var template = $templateCache.get(templateName);
        template = template.replace('caret pull-right', 'icon icon-arrow-select');
        $templateCache.put(templateName, template);

        stateHandler.initialize();
        translationHandler.initialize();

    }
})();
